import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export const CART_SESSION_KEY = 'cart_session_id';

export const getOrCreateCartSessionId = (): string => {
  let sessionId = localStorage.getItem(CART_SESSION_KEY);
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    localStorage.setItem(CART_SESSION_KEY, sessionId);
  }
  return sessionId;
};

/**
 * Anonymous client used only for guest cart rows. It sends the local cart
 * session id as a header so row-level security can verify that the visitor
 * actually owns the guest cart rows they are reading or modifying.
 */
export const guestCartClient = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
  },
  global: {
    headers: {
      'x-cart-session': getOrCreateCartSessionId(),
    },
  },
});
